<div class="extension-info">
  <div class="summary-header">{{ extension.type?.displayName }}</div>
  @if (extension.type?.name === extensionTypes.HuntGroup) {
    <div>
      <h5>Timeout</h5>
      <div class="extension-info-item"> {{ extension.timeout }} seconds </div>
    </div>
  }
  @if (extension.type?.name === extensionTypes.ExternalForward) {
    <div>
      <h5>Forward To</h5>
      <div class="extension-info-item"> {{ extension.forwardTo.toString() | formatPhoneNumbers }} </div>
    </div>
  }
  @if (extension.type?.name === extensionTypes.Fax || extension.type?.name === extensionTypes.VoiceMailbox) {
    <div>
      <h5>Email</h5>
      <div class="extension-info-item"> {{ extension.email }}</div>
    </div>
  }
  @if (extension.type?.name === extensionTypes.AutoAttendant) {
    <div>
      <h5>Keys</h5>
      @for (key of extension.autoAttendantKeys; track key) {
        <div class="extension-info-item"
          >{{ key.keyNumber }}:
          {{ key.routeToExtension ? (key.routeToExtension | formatExtension) : 'Name Directory' }}</div
          >
        }
      </div>
    }
  </div>
